import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ToHtmlPipe } from 'src/app/shared/utilities/to-htmlpipe/to-html.pipe';

@Component({
  selector: 'app-common-subproducts-how-it-works',
  templateUrl: './how-it-works.component.html',
  styleUrls: ['./how-it-works.component.scss'],
  imports: [CommonModule, ToHtmlPipe],
})
export class CommonSubProductsHowItWorksComponent implements OnInit {
  @Input() howItWorksData: any;
  @Input() customClass: any;
  @Input() columns? = 4;
  constructor() {}
  _howItWorksData: any;
  ngOnInit(): void {
    this._howItWorksData = this.howItWorksData;
  }
  ngOnChanges(): void {
    this._howItWorksData = this.howItWorksData;
  }
}
